import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import OButton from 'components/reusable/OButton'
import dayjs from 'dayjs'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import SkillAdd from './SkillAdd'
import SkillEdit from './SkillEdit'
import SkillList from './SkillList'
import helpers from 'utils/helpers'

const SkillManager = () => {
  const { t } = useTranslation()
  const { updatePageName } = useContext(AuthContext)
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [skillAdd, setSkillAdd] = useState(false)
  const [skillEdit, setSkillEdit] = useState(false)
  const [currentItem, setCurrentItem] = useState('')
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })

  const [skillList, setSkillList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [filterData, setFilterData] = useState({
    category: '',
    searchKey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const handleEdit = item => {
    setCurrentItem(item)
    setSkillEdit(!skillEdit)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handleCategory = () => {
    setSkillAdd(!skillAdd)
  }

  const allSkill = async data => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData
      if (
        (data?.deletePage && skillList?.length >= 1) ||
        (isFilter && category && data?.statusChange && skillList?.length >= 1)
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }
      const payload = {
        page,
        pageSize,
        status: category,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchKey,
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }
      const path = apiPath.skillList
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setSkillList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response?.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response?.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs?.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response?.totalDocs,
          null
        )
      })
    } catch (error) {
      console.log('error in get all city list==>>>>', error.message)
    }
  }

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage
    })
  }, [debouncedSearchTerm])

  useEffect(() => {
    allSkill()
  }, [filterData, page, sort])

  const handleReset = () => {
    setFilterData({
      startDate: '',
      endDate: '',
      isReset: true,
      category: '',
      searchKey: '',
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  useEffect(() => {
    updatePageName(t('SKILL_MANAGER'))
  }, [])

  const statusPageData = e => {
    setFilterData({
      ...filterData,
      category: e.target.value,
      isReset: false,
      isFilter: true
    })
    setPage(1)
  }

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                  <div className='relative flex items-center mb-3'>
                    <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                      {!searchTerm ? (
                        <svg
                          aria-hidden='true'
                          className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                          viewBox='0 0 24 24'
                          xmlns='http://www.w3.org/2000/svg'
                          fill='none'
                          stroke='currentColor'
                        >
                          <path
                            strokeWidth='2'
                            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                            strokeLinejoin='round'
                            strokeLinecap='round'
                          />
                        </svg>
                      ) : (
                        ''
                      )}
                    </div>
                    <input
                      className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder={t('SEARCH_BY_SKILL_NAME')}
                      value={searchTerm}
                      title=''
                      type='search'
                      id='default-search'
                      required
                      onChange={e => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <div className='items-center flex ml-3 mb-3'>
                    <select
                      className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                      placeholder=' '
                      onChange={e => statusPageData(e)}
                      id=''
                      type='text '
                      name='category'
                      value={filterData?.category}
                    >
                      <option value=''>
                        {t('O_ALL')}
                      </option>
                      <option value='active'>{t('O_ACTIVE')}</option>
                      <option value='inactive'>{t('O_INACTIVE')}</option>
                    </select>
                  </div>
                  <div className="flex items-center flex-wrap gap-2 mb-3 ml-2">
                    <input
                      type="date"
                      value={filterData.startDate}
                      onChange={(e) => setFilterData({ ...filterData, startDate: e.target.value })}
                      className="border border-gray-300 rounded-lg p-2 text-sm"
                    />
                    <input
                      type="date"
                      value={filterData.endDate}
                      onChange={(e) => setFilterData({ ...filterData, endDate: e.target.value })}
                      className="border border-gray-300 rounded-lg p-2 text-sm"
                    />
                  </div>
                  <OButton
                    type='button'
                    extraClasses='ml-3 mb-3'
                    onClick={handleReset}
                    style={{ borderRadius: '0.5rem' }}
                    label='Reset'
                  />
                </div>
              </div>
              <div className='px-4 ms-auto flex items-center justify-end mb-3'>
                <button
                  className='items-center bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                  onClick={() => handleCategory()}
                  title='Add skill'
                  type='button'
                >
                  + {t('ADD_SKILL')}
                </button>
              </div>
            </form>
            <SkillList
              skillList={skillList}
              page={page}
              allSkill={allSkill}
              handleEdit={handleEdit}
              currentItem={currentItem}
              setSort={setSort}
              sort={sort}
            />
            {skillEdit && (
              <SkillEdit
                allSkill={allSkill}
                handleEdit={handleEdit}
                currentItem={currentItem}
                SkillList={SkillList}
              />
            )}
            {skillAdd && (
              <SkillAdd
                skillAdd={skillAdd}
                allSkill={allSkill}
                handleCategory={handleCategory}
                skillList={skillList}
              />
            )}
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  )
}

export default SkillManager
